var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 167,
    viewBox: "0 0 220 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.069 57.445L0.639404 24.1884L58.8054 0.268066L113.947 26.2238L53.069 57.445Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.639 91.678L53.0137 57.4803L113.947 26.2373L176.424 57.4803L114.639 91.678Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.639 97.2869L113.947 57.4803V26.2373L176.424 57.4803L114.639 97.2869Z",
    fill: "#6B6B6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.719 166.832L53.0137 127.778V57.481L114.719 91.5078V166.832Z",
    fill: "#75B09C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.719 166.832L176.424 127.778V57.481L114.719 91.8482V166.832Z",
    fill: "#89CFB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.186 34.5126V32.7238C110.186 31.6074 110.402 30.5798 110.834 29.641C111.265 28.6768 112.001 27.6619 113.041 26.5962C113.777 25.835 114.297 25.1626 114.601 24.579C114.906 23.97 115.058 23.3865 115.058 22.8282C115.058 22.0924 114.779 21.5215 114.221 21.1155C113.663 20.7096 112.889 20.5066 111.899 20.5066C110.91 20.5066 109.907 20.6715 108.892 21.0014C107.903 21.3312 106.977 21.7626 106.114 22.2954V17.4618C107.028 16.929 108.081 16.5103 109.273 16.2058C110.491 15.9013 111.671 15.7491 112.813 15.7491C114.335 15.7491 115.705 15.9775 116.923 16.4342C118.166 16.8655 119.131 17.5379 119.816 18.4514C120.526 19.3648 120.881 20.5573 120.881 22.029C120.881 22.8663 120.729 23.6783 120.425 24.4648C120.12 25.2514 119.689 25.9872 119.131 26.6723C118.598 27.3574 117.963 28.0044 117.228 28.6134C115.984 29.6283 115.122 30.5037 114.64 31.2395C114.183 31.9499 113.904 32.6604 113.802 33.3708L113.65 34.5126H110.186ZM108.816 43V36.9104H115.02V43H108.816Z",
    fill: "#4D4D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/noOrders.060949c260f445f46a080a5ca818c9aa.svg";
export { ForwardRef as ReactComponent };